<div class="investment-jurisdiction-row">
  <span class="item-content col-3">{{ title }}</span>
  <gstar-entity-types-combobox
    class="w-50 col-7 entity-type-combobox"
    [onlyDefaults]="true"
    [value]="defaultTargetEntityType()"
    [required]="true"
    (selectEntityType)="handleTargetEntityTypeChange($event)"
    (clearTargetEntityTypeValue)="clearTargetEntityTypeValue()" />
  <div class="investment-jurisdiction-button">
    <button (click)="onRemove()" class="Appkit4-icon icon-delete-outline col-2">
      &nbsp;
    </button>
  </div>
</div>
